import { BaseStateMiddleware, IActionHandler, IMiddlewareConfig } from 'smarthub-common'
import {
  ActionCollection as Collection,
  createActionMiddleware as createMiddleware,
  coreActionMiddleware as core,
} from 'smarthub-core'

export const actionMiddleware = (): IMiddlewareConfig<BaseStateMiddleware, IActionHandler> => {
  const collection = new Collection()
  const middleware = createMiddleware(core, collection.middleware)
  return {
    middleware,
    collection,
  }
}
